import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMessage, setProfil } from "../../redux";
import Input from "../Input";
import CheckList from "../CheckList";
import "./style.css"

const el = [
    {
        h2: `1 — Identité du professionnel`,
        sub: `Merci de renseigner vos informations professionnelles générales`,
        sub2: `Ces données constitueront votre fiche dans l’annuaire PSOA.`
    },
    {
        h2: `2 — Outils de communication privilégiés`,
        sub: `Choisissez les outils et canaux que vous utilisez pour différents types d’échanges : patient, administratif, avis/conseils, réunions.`,
    },
    {
        h2: `3 — Modalités de contact selon le degré d’urgence`,
        sub: `Indiquez comment vous préférez être contacté en fonction du délai de réponse attendu (<2h, <24h, <1 semaine).`,
    },
    {
        h2: `4 — Informations attendues de la part des autres professionnels`,
        sub: `Renseignez ce que vous attendez des autres professionnels lors de communications interprofessionnelles. Renseignez uniquement les attentes qui concernent votre profession par exemple : je suis médecin dans la partie "Informations attendues du Kinésithérapeute" je veux que les Kinésithérapeutes m'envoient leur demande de renouvellement d'ordonnance via mon adresse mail sécurisée MSsanté.`,
    },
    {
        h2: `5 — Mes publics de prédilection`,
        sub: `Indiquez les types de publics avec lesquels vous travaillez le plus souvent. Sélectionnez toutes les options pertinentes.`,
    },
    {
        h2: `6 — Verification avant inscription`,
        sub: `Merci de renseigner le code à usage unique qui vous a été envoyé pars mail à`,
    },
];

function FormSign({ form, setForm }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [popup, setPopup] = useState(false);
    const [msgAlert, setAlert] = useState(false);
    const [alertCss, setAlertCss] = useState({
        lastName: false,
        firstName: false,
        profession: false,
        otherProfession: false,
        mainLocation: false,
        secondaryLocations: false,
        proPhone: false,
        secretaryPhone: false,
        proEmail: false,
        secureProEmail: false,
        password: false,
        confPassword: false,

        patientComTool: false,
        adminComTool: false,
        interproTool: false,
        meetingTool: false,
        urgentContact: false,
        dailyContact: false,
        weeklyContact: false,
        targetAudiences: false,

        alert: false
    })

    const next = () => {
        setAlert(false);
        window.scrollTo(0, 0);

        let newAlert = {};
        let hasError = false;

        switch (page) {
            case 1:
                newAlert = {
                    ...alertCss,
                    lastName: form.lastName === '',
                    firstName: form.firstName === '',
                    profession: form.profession === '',
                    otherProfession: form.profession === 'AUTRE' && form.otherProfession === '',
                    mainLocation: form.mainLocation === '',
                    secondaryLocations: form.secondaryLocations === '',
                    proPhone: form.proPhone === '',
                    secretaryPhone: form.secretaryPhone === '',
                    proEmail: form.proEmail === '',
                    secureProEmail: form.secureProEmail === '',
                    password: form.password === '' || form.password.length < 8,
                    confPassword: form.confPassword !== form.password,
                    code: false
                };
                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 2:
                newAlert = {
                    ...alertCss,
                    patientComTool: form.patientComTool.length === 0 || (form.patientComTool.length === 1 && form.patientComTool.includes('AUTRE') && form.otherPatientComTool === ''),
                    adminComTool: form.adminComTool.length === 0 || (form.adminComTool.length === 1 && form.adminComTool.includes('AUTRE') && form.otherAdminComTool === ''),
                    interproTool: form.interproTool.length === 0 || (form.interproTool.length === 1 && form.interproTool.includes('AUTRE') && form.otherInterproTool === ''),
                    meetingTool: form.meetingTool.length === 0 || (form.meetingTool.length === 1 && form.meetingTool.includes('AUTRE') && form.otherMeetingTool === ''),
                };

                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 3:
                newAlert = {
                    ...alertCss,
                    urgentContact: form.urgentContact.length === 0 || (form.urgentContact.length === 1 && form.urgentContact.includes('AUTRE') && form.otherUrgentContact === ''),
                    dailyContact: form.dailyContact.length === 0 || (form.dailyContact.length === 1 && form.dailyContact.includes('AUTRE') && form.otherDailyContact === ''),
                    weeklyContact: form.weeklyContact.length === 0 || (form.weeklyContact.length === 1 && form.weeklyContact.includes('AUTRE') && form.otherWeeklyContact === ''),
                };

                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return
                break;

            case 4:
                break

            case 5:
                newAlert = {
                    ...alertCss,
                    targetAudiences: form.targetAudiences.length === 0 || (form.targetAudiences.length === 1 && form.targetAudiences.includes('AUTRE') && form.otherTargetAudiences === ''),
                };

                setAlertCss(newAlert);

                hasError = Object.values(newAlert).some(v => v === true);
                if (hasError) return

                signup();
                return

            default:
                return
        }
        setPage(page + 1)
    }

    const signup = async () => {
        dispatch(setMessage('Chargement en cour, merci de patienter'));

        const body = {
            email: form.email,
            lastName: form.lastName,
            firstName: form.firstName,
            profession: form.profession === 'AUTRE' ? form.otherProfession : form.profession,
            mainLocation: form.mainLocation,
            secondaryLocations: form.secondaryLocations,
            proPhone: form.proPhone,
            secretaryPhone: form.secretaryPhone,
            proEmail: form.proEmail,
            secureProEmail: form.secureProEmail,
            password: form.password,

            patientComTool: form.patientComTool,
            otherPatientComTool: form.otherPatientComTool,
            adminComTool: form.adminComTool,
            otherAdminComTool: form.otherAdminComTool,
            interproTool: form.interproTool,
            otherInterproTool: form.otherInterproTool,
            meetingTool: form.meetingTool,
            otherMeetingTool: form.otherMeetingTool,

            urgentContact: form.urgentContact,
            otherUrgentContact: form.otherUrgentContact,
            dailyContact: form.dailyContact,
            otherDailyContact: form.otherDailyContact,
            weeklyContact: form.weeklyContact,
            otherWeeklyContact: form.otherWeeklyContact,

            targetAudiences: form.targetAudiences,
            otherTargetAudiences: form.otherTargetAudiences,
            importantInfo: form.importantInfo,

            infoExpected: {
                physiotherapist: form.infoExpected.physiotherapist,
                pharmacist: form.infoExpected.pharmacist,
                ide: form.infoExpected.ide,
                others: form.infoExpected.others,
            },

            code: 'none'
        }

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/signup`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 201) {
            setAlertCss(res.message)
            return
        }
        setPage(6);
    }

    const verification = async (e) => {
        e.preventDefault();

        if (form.code === '') {
            setAlertCss({ ...alertCss, code: true });
            return
        }

        dispatch(setMessage('Chargement en cour, merci de patienter'));

        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/signup`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: form.email,
                code: form.code
            })
        })
        const res = await req.json();
        dispatch(setMessage());

        if (req.status !== 200) {
            alert(res.message)
            return
        }

        const { token, ...resFiltered } = res;

        sessionStorage.setItem('status', res.status);
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('email', form.email);
        sessionStorage.setItem('password', form.password);

        dispatch(setProfil(resFiltered));
        navigate('/');
    }

    if (!popup) return (
        <div className="popup_overlay">
            <div className="popup_content">

                <h2>Information du patient et cadre légal</h2>

                <p className="popup_intro">
                    Conformément à l’article <strong>L.1110-4 du Code de la santé publique</strong>,
                    vous vous engagez à informer le patient avant tout échange d’informations le concernant.
                </p>

                <div className="popup_box">
                    <p>Pour rappel :</p>

                    <ul>
                        <li>✅ L’échange est autorisé <strong>uniquement si nécessaire aux soins</strong></li>
                        <li>✅ Le patient doit être <strong>informé</strong></li>
                        <li>✅ Son <strong>consentement est requis</strong> hors « équipe de soins »</li>
                        <li>✅ Il peut <strong>s’opposer à tout moment</strong></li>
                    </ul>
                </div>

                <button
                    className="popup_btn"
                    onClick={() => setPopup(true)}
                >
                    J’ai compris et je continue
                </button>

            </div>
        </div>
    );

    return (
        <form className="form_signup" onSubmit={verification}>
            <h1>Fiche création Annuaire PSOA</h1>

            {page === 1 &&
                <p className="text">
                    Ce questionnaire permet de remplir l'annuaire PSOA avec vos coordonnées pro. Vous pouvez avoir accès aux informations de l'annuaire via un lien reçu
                    par mail une fois le questionnaire remplit.
                    <strong> VOUS N'ETES PAS OBLIGE DE REMPLIR TOUTES LES SECTIONS DE SUITE, VOUS POUVEZ COMPLETER PLUS TARD CELLES QUI NE SONT PAS OBLIGATOIRE.</strong>
                </p>
            }

            {page !== 6 && <p className="text">Lorsque vous soumettez ce formulaire, il ne collecte pas automatiquement vos détails, tels que le nom et l’adresse e-mail, sauf si vous le fournissez vous-même.</p>}

            {page !== 6 && <p className="text"><span className="red">*</span> Obligatoire</p>}

            <div className="head">
                <h2>{el[page - 1].h2}</h2>
                <p className="text">
                    {el[page - 1].sub} {page === 6 && `"${form.email}"`}
                    {el[page - 1].sub2 ? <br /> : ''}
                    {el[page - 1].sub2 ? el[page - 1].sub2 : ''}
                </p>
            </div>

            {page === 1 &&
                <div className="fields">
                    <Input
                        label='Nom' field='lastName'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                    />
                    <Input
                        label='Prénom' field='firstName'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                    />

                    <CheckList
                        label='Profession' field='profession' otherField='otherProfession'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={false} type={0}
                    />

                    <Input
                        label='Lieu d’exercice' field='mainLocation'
                        form={form} setForm={setForm}
                        ex='Ex : Champtoceaux, Liré, Bouzillé…' alertCss={alertCss}
                    />
                    <Input
                        label='Adresse professionnelle' field='secondaryLocations'
                        form={form} setForm={setForm}
                        ex="si plusieurs lieux d'exercice vous pourrez le préciser dans la partie notes." alertCss={alertCss}
                    />

                    <Input
                        label='Téléphone direct' field='proPhone'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                    />
                    <Input
                        label='Téléphone secrétariat' field='secretaryPhone'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                    />

                    <Input
                        label='Email professionnel (visible pour les professionnels)' field='proEmail'
                        form={form} setForm={setForm}
                        ex="Email avec lequel vous voulez qu'un professionnel de santé vous contacte, sans donnés sensibles (organisation de réunion, demande administratives, etc..)" alertCss={alertCss}
                    />
                    <Input
                        label='Email professionnel sécurisé' field='secureProEmail'
                        form={form} setForm={setForm}
                        ex="Email avec lequel vous voulez qu'un professionnel de santé vous contacte, avec donnés sensibles (échange sur un patient commun, envoi de CR patient)." alertCss={alertCss}
                    />

                    <Input
                        label='Mot de passe' field='password'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                        pw={true}
                    />
                    <Input
                        label='Confirmer le mot de passe' field='confPassword'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                        pw={true}
                    />
                </div>
            }

            {page === 2 &&
                <div className="fields">
                    <CheckList
                        label='Quel outil préférez vous utiliser pour communiquer au sujet d’un patient ?'
                        field='patientComTool' otherField='otherPatientComTool'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <CheckList
                        label='Quel outil privilégiez vous pour les échanges administratifs ?'
                        field='adminComTool' otherField='otherAdminComTool'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <CheckList
                        label='Quel outil préférez vous pour un avis ou un conseil interprofessionnel ?'
                        field='interproTool' otherField='otherInterproTool'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <CheckList
                        label='Quel outil souhaitez-vous utiliser pour organiser une réunion ?'
                        field='meetingTool' otherField='otherMeetingTool'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />
                </div>
            }

            {page === 3 &&
                <div className="fields">
                    <CheckList
                        label='En cas d’urgence (< 2 heures), comment souhaitez vous être contacté ?'
                        field='urgentContact' otherField='otherUrgentContact'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <CheckList
                        label='Pour une réponse sous 24 heures, comment préférez vous être contacté ?'
                        field='dailyContact' otherField='otherDailyContact'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <CheckList
                        label='Pour un délai d’environ une semaine, quel canal préférez vous ?'
                        field='weeklyContact' otherField='otherWeeklyContact'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />
                </div>
            }

            {page === 4 &&
                <div className="fields">
                    <div className="inp_field">
                        <label>Informations attendues du médecin</label>

                        <textarea
                            placeholder="Entrez votre réponse"
                            onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, physiotherapist: e.target.value } })}
                            value={form.infoExpected.physiotherapist}
                        ></textarea>
                    </div>

                    <div className="inp_field">
                        <label>Informations attendues du pharmacien</label>

                        <textarea
                            placeholder="Entrez votre réponse"
                            onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, pharmacist: e.target.value } })}
                            value={form.infoExpected.pharmacist}
                        ></textarea>
                    </div>

                    <div className="inp_field">
                        <label>Informations attendues de l’Infirmier / IDE</label>

                        <textarea
                            placeholder="Entrez votre réponse"
                            onChange={(e) => setForm({ ...form, infoExpected: { ...form.infoExpected, ide: e.target.value } })}
                            value={form.infoExpected.ide}
                        ></textarea>
                    </div>

                    <p className="text">Une fois votre profil inscrit, vous pourrez renseigner des "Informations attendues" spécifiques à vos besoins</p>
                </div>
            }

            {page === 5 &&
                <div className="fields">
                    <CheckList
                        label='Pour quels publics travaillez vous le plus souvent ?'
                        field='targetAudiences' otherField='otherTargetAudiences'
                        form={form} setForm={setForm} alertCss={alertCss}
                        multy={true} type={page - 1}
                    />

                    <div className="inp_field">
                        <label>Autre information important à mentionner ?</label>

                        <textarea
                            placeholder="Entrez votre réponse"
                            onChange={(e) => setForm({ ...form, importantInfo: e.target.value })}
                            value={form.importantInfo}
                        ></textarea>
                    </div>
                </div>
            }

            {page === 6 &&
                <div className="fields">
                    <Input
                        label='Code de vérification' field='code'
                        form={form} setForm={setForm}
                        alertCss={alertCss}
                    />
                </div>
            }

            <div className="panel">
                {page !== 6 && <button type="button" className="btn_prev" onClick={() => setPage(page - 1)} disabled={page === 1}>Précedent</button>}
                {page !== 6 && <button type="button" className="btn_next" onClick={() => next()}>{page === 5 ? 'Confirmer' : 'Suivant'}</button>}
                {page === 6 && <button className="btn_submit">Valider</button>}
            </div>

            {msgAlert && <p className="alertMsg">Un ou plussieurs champs sont manquant, merci de renseigner toutes les informations requise.</p>}
        </form>
    )
}

export default FormSign;